var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['mask-loading', _vm.loading ? 'loading' : 'unloading'],style:({ 'display': _vm.show ? 'block' : 'none' })},[_c('van-overlay',{attrs:{"show":_vm.loading}},[_c('van-loading',{attrs:{"size":"24px","color":"#fff"}},[(_vm.hasTxt)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }